import * as React from "react";
import { Button, ThematicBreak } from "../Components";
import { Document, File, FileElement, Folder, FolderElement } from ".";
import Typography from "@material-ui/core/Typography";
import "@metricell/smarttoolscore/dist/module/Styles/metricell.css";

export interface IDocumentManagerProps {
    bindFile: (file: File) => void;
    bindNewDashboard: () => void;
    documents: Array<{ id: string; name: string }>;
    openExplorer: () => void;
    refresh: () => void;
    smartBoardsUrl: string;
}

export const DocumentManager: React.FunctionComponent<IDocumentManagerProps> = (
    props,
): React.ReactElement => {
    const files: Document[] = [];

    if (props.documents) {
        for (let i = 0; i < props.documents.length; i++) {
            const doc: { id: string; name: string } = props.documents[i];

            files.push(new Document(doc.name, doc.id));
        }
    }

    const baseFolder: Folder = new Folder(`Default`);

    for (let i = 0; i < files.length; i++) {
        baseFolder.add(files[i], 0);
    }

    const folderElements: React.ReactNode[] = [];

    for (let i = 0; i < baseFolder.folders.length; i++) {
        folderElements.push(
            <FolderElement
                key={baseFolder.folders[i].name}
                {...props}
                contents={baseFolder.folders[i]}
            />,
        );
    }

    const fileElements: React.ReactNode[] = [];

    const allFiles: File[] = baseFolder.getAllFiles();

    for (let i = 0; i < allFiles.length; i++) {
        fileElements.push(
            <FileElement
                key={allFiles[i].name}
                {...props}
                content={allFiles[i]}
            />,
        );
    }

    return (
        <div className={`document`}>
            <div className={`document-buttoncontainer`}>
                <Button
                    className={`buttoncontainer-button2`}
                    onClick={props.bindNewDashboard}
                    text={`Create New Board`}
                />
            </div>
            <div className={`document-buttoncontainer`}>
                <Button
                    className={`buttoncontainer-button2`}
                    onClick={props.openExplorer}
                    text={`Open Library`}
                />
            </div>
            <Typography
                className={`top-dashboard-title`}
                gutterBottom
                variant={`body2`}
            >
                Most recent:
            </Typography>
            <ThematicBreak className={`document-thematicbreak`} />

            <div className={`documenttree`}>
                <div className={`scroll`}>{fileElements}</div>
            </div>
        </div>
    );
};
